import { Map } from 'immutable';
import actions, { getView } from './actions';

const initState = new Map({
  collapsed: window.innerWidth > 1220 ? false : true,
  view: getView(window.innerWidth),
  appWidth: window.innerWidth,
  appHeight: window.innerHeight,
  isHambugerMenuCollapsed: false,
});
export default function appReducer(state = initState, action) {
  const appState = state.toJS();
  switch (action.type) {
    case actions.UPDATE_APP_VIEW:
      return new Map({
        ...appState,
        view: getView(window.innerWidth),
        appWidth: action.width
      });
    case actions.UPDATE_APP_HEIGHT:
      return new Map({
        ...appState,
        appHeight: action.height
      });
    case actions.SET_IS_HAMBURGER_MENU_COLLAPSED:
      return new Map({
        ...appState,
        isHambugerMenuCollapsed: action.isCollapsed
      });
    default:
      return state;
  }
}
